import type { FileEditSchemaEditPayload } from '@repo/schemas/file/fileEdit';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DirectoryKey } from '#directory/keys';

import { FileService } from './fileService';
import { FileKey } from './keys';

export function useEditFile(directoryId?: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: FileEditSchemaEditPayload) => FileService.editFile(data).then((response) => response.data),
    onSuccess: (data, variables) => {
      if (directoryId) {
        queryClient.invalidateQueries({
          queryKey: [DirectoryKey.DIRECTORY, directoryId],
        });
      }
      queryClient.invalidateQueries({
        queryKey: [FileKey.FILES, data.id],
      });
      if (variables.permissionChanges) {
        queryClient.invalidateQueries({
          queryKey: [FileKey.FILE_PERMISSIONS, data.id],
        });
      }
    },
  });
}
